import { render, staticRenderFns } from "./seller-transaction.vue?vue&type=template&id=6171b031&scoped=true&"
import script from "./seller-transaction.vue?vue&type=script&lang=js&"
export * from "./seller-transaction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6171b031",
  null
  
)

export default component.exports